import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { PackageIcon, TruckIcon, AlertTriangleIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden pt-24 pb-32" data-id="element-96">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-97">
        <img src="https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=1600" alt="Courier driver with delivery van" className="w-full h-full object-cover" data-id="element-98" />
        <div className="absolute inset-0 bg-slate-900/80 mix-blend-multiply" data-id="element-99" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent" data-id="element-100" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-101">
        <div className="max-w-4xl mx-auto text-center" data-id="element-102">
          <div className="inline-flex items-center bg-red-600 text-white px-4 py-2 rounded-full font-bold mb-6 shadow-lg" data-id="element-103">
            <AlertTriangleIcon className="w-5 h-5 mr-2" data-id="element-104" />
            UK's Leading Emergency Courier Providers
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6" data-id="element-105">
            Emergency Courier Providers & Item Delivery Across the UK
          </h1>

          <p className="text-xl md:text-2xl text-blue-200 font-medium mb-6" data-id="element-106">
            Universal Global Logistics supplies professional, vetted courier
            drivers for hire and provides reliable item delivery services
            nationwide.
          </p>

          <div className="bg-white/10 backdrop-blur-md border border-white/20 p-4 rounded-xl mb-8 inline-block shadow-xl" data-id="element-107">
            <p className="text-white font-bold text-lg md:text-xl" data-id="element-108">
              Hire experienced courier drivers on demand — plus emergency parcel
              & item delivery.
            </p>
          </div>

          <p className="text-lg text-slate-300 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-109">
            Whether you need a professional driver at short notice or a same-day
            item delivery, our experienced logistics network is ready to support
            your business anywhere in the UK.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-110">
            <Link to="/quote" className="w-full sm:w-auto" data-id="element-111">
              <Button size="lg" className="w-full sm:w-auto text-lg px-8 bg-primary hover:bg-primary/90 text-white border-none" data-id="element-112">
                Hire a Driver
              </Button>
            </Link>
            <Link to="/contact" className="w-full sm:w-auto" data-id="element-113">
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg px-8 bg-white/10 text-white border-white/30 hover:bg-white/20 hover:text-white" data-id="element-114">
                Book a Delivery
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}